import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { IconComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';
import { TableComponent } from '@mitsubishi/ui/table';

import { LetDirective } from '@ngrx/component';

import { StudyModelsComponent } from './study-models.component';

@NgModule({
  declarations: [StudyModelsComponent],
  imports: [
    CommonModule,
    TableComponent,
    LetDirective,
    SectionTitleComponent,
    ApmTranslatePipe,
    IconComponent,
    MatTooltip,
  ],
  exports: [StudyModelsComponent],
})
export class StudyModelsModule {}
